import clsx from 'clsx';
import { forwardRef, useState } from 'react';
import { InputProps } from 'src/modules/common/components/DecimalField/types';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

export const DecimalInput = forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement>): React.ReactElement => {
    const {
        inputSize = 'md',
        disabled,
        endAdornment,
        labelText,
        labelPostfix,
        shaded = true,
        outlined = false,
        id,
        className,
        ...restProps
    } = props;

    const [endAdornmentWidth, setEndAdornmentWidth] = useState<number | null>(null);

    return (
        <div
            data-testid="decimal-input-wrapper"
            className={clsx(
                {
                    'vss-decimal-input-wrapper': true,
                },
                className,
            )}
        >
            <label
                data-testid="decimal-input-label"
                className={clsx(
                    {
                        'vss-decimal-input__label': true,
                        'vss-decimal-input__label--disabled': disabled,
                    },
                )}
                htmlFor={id}
            ><I18n messageId={labelText}/>{labelPostfix !== undefined ? labelPostfix : ''}
            </label>

            <div
                className="vss-decimal-input__end-adornment-wrapper"
                style={{ paddingRight: `${Number(endAdornmentWidth)}px` }}
            >
                <input
                    {...restProps}
                    data-testid="decimal-input"
                    id={id}
                    ref={ref}
                    disabled={disabled}
                    className={clsx({
                        'vss-decimal-input': true,
                        'vss-decimal-input--outlined': outlined,
                        'vss-decimal-input--shaded': shaded,
                        [`vss-decimal-input--${inputSize}`]: true,
                    })}
                />

                <div
                    className="vss-decimal-input__end-adornment"
                    ref={(current) => setEndAdornmentWidth(current?.getBoundingClientRect().width || 0)}
                >
                    {endAdornment}
                </div>
            </div>
        </div>
    );
});
